import React from 'react';
import { formatterCurrency } from '../../../utils/methods';
import {
  SummaryCardsRow,
  SummaryCard,
  SummaryCardTitle,
  SummaryCardValue,
  SummaryCardCount,
} from './UserPaymentHistoryStyled';

// Figma 4912:7140 — 요약 카드.
// background: 결제/할인은 teal, 환불/미수는 gray.
// value 강조: 결제금액=teal, 환불/미수=orange, 그 외=기본 회색.
//
// 양도 수수료 카드는 백엔드에 데이터가 없어 일단 제외. 양도 수수료 기능이 BE에 들어오면 다시 추가한다.
const CARDS = [
  {
    key: 'paid',
    title: '총 결제금액',
    amountField: 'totalPaidAmount',
    countField: 'totalPaidCount',
    background: 'teal',
    valueColor: 'teal',
  },
  {
    key: 'discount',
    title: '할인금액',
    amountField: 'totalPaymentDiscountAmount',
    countField: 'totalPaymentDiscountCount',
    background: 'teal',
    valueColor: 'default',
  },
  {
    key: 'usedPoint',
    title: '포인트사용',
    amountField: 'totalUsedPoint',
    background: 'teal',
    valueColor: 'default',
  },
  {
    key: 'refund',
    title: '환불금액',
    amountField: 'totalRefundAmount',
    countField: 'totalRefundCount',
    background: 'gray',
    valueColor: 'orange',
  },
  {
    key: 'outstanding',
    title: '미수금액',
    amountField: 'totalOutstandingAmount',
    countField: 'totalOutstandingCount',
    background: 'gray',
    valueColor: 'orange',
  },
];

const UserPaymentHistorySummaryTable = ({ totalPayment }) => {
  const formatAmount = field => `${formatterCurrency(Number(totalPayment?.[field]) || 0)}원`;
  const formatCount = field => `${totalPayment?.[field] ?? 0}건`;

  return (
    <SummaryCardsRow>
      {CARDS.map(card => (
        <SummaryCard key={card.key} variant={card.background}>
          <SummaryCardTitle>{card.title}</SummaryCardTitle>
          <SummaryCardValue valueColor={card.valueColor}>{formatAmount(card.amountField)}</SummaryCardValue>
          {/* <SummaryCardCount>{formatCount(card.countField)}</SummaryCardCount> */}
        </SummaryCard>
      ))}
    </SummaryCardsRow>
  );
};

export default UserPaymentHistorySummaryTable;
